<script>
const CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
}
export default {
  name: 'Timepicker',
  props: {
    value: {
      required: true,
      type: Object
    },
    hideClearButton: {
      type: Boolean
    },
    format: {
      type: String,
      default: 'HH:mm'
    },
    minuteInterval: {
      type: Number,
      default: 1,
      validator: val => {
        if (val < 0) {
          throw new Error('minute-interval must be greater than 0')
        }
        return true;
      }
    },
    secondInterval: {
      type: Number,
      default: 1,
      validator: val => {
        if (val < 0) {
          throw new Error('second-interval must be greater than 0')
        }
        return true;
      }
    },
    disabled: { type: Boolean },
    disabledValues: {
      type: Object,
      default: () => { return { hour: [], minute: [], second: [], apm: [] } }
    }
  },
  data () {
    return {
      showDropdown: false
    }
  },
  computed: {
    displayTime () {
      let formatString = this.format
      if (this.value[this.hourType]) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.value[this.hourType])
      }
      if (this.value[this.minuteType]) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.value[this.minuteType])
      }
      if (this.value[this.secondType] && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.value[this.secondType])
      }
      if (this.value[this.apmType] && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.value[this.apmType])
      }
      return formatString
    },
    showClearBtn () {
      return !!this.value[this.hourType] || !!this.value[this.minuteType]
    },
    hourType () {
      return this.checkAcceptingType(CONFIG.HOUR_TOKENS, this.format, 'HH')
    },
    minuteType () {
      return this.checkAcceptingType(CONFIG.MINUTE_TOKENS, this.format, 'mm')
    },
    secondType () {
      return this.checkAcceptingType(CONFIG.SECOND_TOKENS, this.format)
    },
    apmType () {
      return this.checkAcceptingType(CONFIG.APM_TOKENS, this.format)
    },
    hours () {
      const hoursCount = this.isTwelveHours ? 12 : 24
      let hours = []
      for (let i = 0; i < hoursCount; i++) {
        switch(this.hourType) {
          case 'H':
            hours.push( String(i) )
            break;
          case 'HH':
            hours.push( ('0' + i).substr(-2, 2) )
            break;
          case 'h':
          case 'k':
            hours.push( String(i + 1) )
            break;
          case 'hh':
          case 'kk':
            hours.push( ('0' + String(i + 1)).substr(-2, 2) )
            break;
        }
      }
      return hours;
    },
    minutes () {
      let minutes = []
      for (let i = 0; i < 60; i += this.minuteInterval) {
        switch(this.minuteType) {
          case 'm':
            minutes.push(String(i))
            break;
          case 'mm':
            minutes.push( ('0' + i).substr(-2, 2) )
            break;
        }
      }
      return minutes
    },
    seconds () {
      let seconds = []
      for (let i = 0; i < 60; i += this.secondInterval) {
        switch(this.secondType) {
          case 's':
            seconds.push(i)
            break;
          case 'ss':
            seconds.push( ('0' + i).substr(-2, 2) )
            break;
        }
      }
      return seconds
    },
    apms () {
      switch (this.apmType) {
        case 'A':
          return ['AM', 'PM']
        case 'a':
          return ['am', 'pm']
        default:
          return []
      }
    },
    isTwelveHours () {
      return this.hourType === 'h' || this.hourType === 'hh'
    },
    isPastNoon () {
      return this.apm === 'pm' || this.apm === 'PM'
    },
  },
  methods: {
    checkAcceptingType (validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) { return '' }
      const length = validValues.length
      for (let i = 0; i < length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i]
        }
      }
      return fallbackValue || ''
    },
    toggleDropdown () {
      this.showDropdown = !this.showDropdown && !this.disabled
      if (!this.showDropdown) {
        this.$emit('blur', {
          ...this.value
        })
      } else {
        // focus on the first select element
        setTimeout(() => {this.$el.querySelector("select.hours").focus();}, 0);
      }
    },
    clearTime () {
      let time = {}
      time[this.hourType] = ''
      time[this.minuteType] = ''
      time[this.secondType] = ''
      this.apm = this.apms[0]
      this.$emit('input', time)
    },
    isInsideComponent(el) {
      while (el) {
        if (el === this.$el) {
          return true;
        } else {
          el = el.parentElement;
        }
      }
      return false;
    },
    onLoseFocus(e) {
      if (this.showDropdown && e.relatedTarget && !this.isInsideComponent(e.relatedTarget)) {
        this.toggleDropdown();
      }
    },
    onKeyDown(e) {
      if (e && e.key === "Escape" && this.showDropdown) {
          this.toggleDropdown();
      }
    }
  }
}
</script>

<template>
<span class="time-picker" @keydown="onKeyDown">
  <input class="display-time" :readonly="!disabled" :disabled="disabled" :value="displayTime" type="text" @focusin.stop="toggleDropdown"  style="height:38px;"/>
  <span class="clear"  @click.stop="toggleDropdown" ><span style="background-color: #24C656;border-top-right-radius: 4px;border-bottom-right-radius: 4px;width:33px;"><img src="@/assets/images/clock.svg" alt="" style="padding: 12px 09px;" ></span></span>
  <div class="time-picker-overlay" v-if="showDropdown" @click.stop="toggleDropdown"></div>
  <div class="dropdown" v-show="showDropdown" @focusout="onLoseFocus" style="margin-top:6px;">
    <div class="select-list">
      <select class="hours" v-model="value[hourType]" @change="$emit('input', value)">
        <option disabled v-text="hourType" value="" class="hint"></option>
        <option
                v-for="hr in hours"
                v-text="hr"
                v-show="disabledValues.hour.indexOf(hr) === -1"
                :class="{active: value[hourType] === hr}">

        </option>
      </select>
      <select class="minutes" v-model="value[minuteType]" @change="$emit('input', value)">
        <option disabled v-text="minuteType" value="" class="hint"></option>
        <option
                v-for="m in minutes"
                v-text="m"
                v-show="disabledValues.minute.indexOf(m) === -1"
                :class="{active: value[minuteType] === m}">

        </option>
      </select>
      <select class="seconds" v-model="value[secondType]" v-if="secondType" @change="$emit('input', value)">
        <option disabled v-text="secondType" value="" class="hint"></option>
        <option
                v-for="s in seconds"
                v-text="s"
                v-show="disabledValues.second.indexOf(s) === -1"
                :class="{active: value[secondType] === s}">

        </option>
      </select>
      <select class="apms" v-model="value[apmType]" v-if="apmType" @change="$emit('input', value)">
        <option disabled v-text="apmType" value="" class="hint"></option>
        <option
                v-for="a in apms"
                v-text="a"
                v-show="disabledValues.apm.indexOf(a) === -1"
                :class="{active: value[apmType] === a}">

        </option>
      </select>
    </div>
  </div>
</span>
</template>

<style>
.time-picker {
  display: inline-block;
  position: relative;
  font-size: 1em;
  width: 10em;
  font-family: sans-serif;
  vertical-align: middle;
}

.time-picker * {
  box-sizing: border-box;
}

.time-picker input.display-time {
  border: 1px solid #d2d2d2;
  width: 10em;
  height: 2.2em;
  padding: 0.3em 0.5em;
  font-size: 1em;
}

.time-picker .clear-btn {
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  margin-top: -0.15em;
  z-index: 3;
  font-size: 1.1em;
  line-height: 1em;
  vertical-align: middle;
  width: 1.3em;
  color: #d2d2d2;
  background: rgba(255,255,255,0);
  text-align: center;
  font-style: normal;

  -webkit-transition: color .2s;
  transition: color .2s;
}

.time-picker .clear-btn:hover {
  color: #797979;
  cursor: pointer;
}

.time-picker .time-picker-overlay {
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.time-picker .dropdown {
  position: absolute;
  z-index: 5;
  top: calc(2.2em + 2px);
  left: 0;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0,0,0,0.15);
  width: 10em;
  font-weight: normal;
}

.time-picker .dropdown .select-list {
  width: 10em;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: space-between;
}

.time-picker .dropdown select {
  padding: 0;
  margin: 0;

  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

.time-picker .dropdown select option {
  text-align: center;
  padding: 0.3em 0;
  color: #161616;
}

.time-picker .dropdown select option:not(.hint):hover {
  background: rgba(0,0,0,.08);
  color: #161616;
  cursor: pointer;
}

.time-picker .dropdown select option.active,
.time-picker .dropdown select option.active:hover {
  background: #41B883;
  color: #fff;
}

.time-picker .dropdown .hint {
  color: #a5a5a5;
  cursor: default;
  font-size: 0.8em;
}
.clear{
    position: absolute;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  /*margin-top: -0.15em;*/
  z-index: 3;
  font-size: 1.1em;
  line-height: 1em;
  vertical-align: middle;
  /*width: 1.3em;*/
  color: #d2d2d2;
  background: rgba(255,255,255,0);
  text-align: center;
  font-style: normal;

  -webkit-transition: color .2s;
  transition: color .2s;
}
</style>